import { readString } from 'react-papaparse';
import React from 'react';

interface CsvPreviewTableProps {
  data?: string;
  csvDelimiter?: string;
  tableClassName?: string;
  responsive?: boolean;
  maxRows?: number;
}

const CsvPreviewTable: React.FC<CsvPreviewTableProps> = ({
  data,
  csvDelimiter = ',',
  tableClassName = 'table table',
  responsive = false,
  maxRows = 100
}) => {
  if (!data) return null;

  try {
    const parsed: any = readString(data, {
      delimiter: csvDelimiter,
      header: true,
      skipEmptyLines: true
    } as any);

    const { data: rows, meta } = parsed;

    if (!rows.length || !meta.fields?.length) {
      return (
        <div className="text-muted">
          No valid CSV data to preview
        </div>
      );
    }

    const displayRows = rows.slice(0, maxRows);

    const tableContent = (
      <table className={tableClassName}>
        <thead>
          <tr>
            {meta.fields.map((field: string) => (
              <th key={`header-${field}`}>{field}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {displayRows.map((row: any, index: number) => {
            const rowKey = `row-${index}-${JSON.stringify(Object.values(row)).slice(0, 50)}`;
            return (
              <tr key={rowKey}>
                {meta.fields.map((field: string) => (
                  <td key={`${rowKey}-${field}`}>{row[field] || ''}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );

    return (
      <div>
        {responsive ? (
          <div className="table-responsive">
            {tableContent}
          </div>
        ) : (
          tableContent
        )}
        {rows.length > maxRows && (
          <div className="text-muted small mt-2">
            Showing first {maxRows} of {rows.length} rows
          </div>
        )}
      </div>
    );
  } catch (error) {
    return (
      <div className="text-danger">
        Error parsing CSV: {error instanceof Error ? error.message : 'Unknown error'}
      </div>
    );
  }
};

export default CsvPreviewTable;